import BGI from '../../assets/about-us/new-about-bg.jpg'
import SMAppAboutCredit from '../../containers/App-AboutUs/AboutCredit'
import SMAppVissionAndMission from '../../containers/App-AboutUs/VissionAndMission'
import SMAppOurExtensive from '../../containers/App-AboutUs/OurExtensive'
import SMAppSalesStatistics from '../../containers/App-AboutUs/SalesStatistics'
import SMAppMotorLoanIntroduction from '../../containers/App-AboutUs/MotorLoanIntroduction'
import SMAppHomeContactUs from '../../containers/App-Home/ContactUs'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ScreenWidthPort } from '../../ScreenWidthContext'

export const AppAboutUsScreen: React.FC = () => {
    const { screenWidth } = ScreenWidthPort()
    
    const { t } = useTranslation()

    // ======================= VIEWS
    return (
        <>
            <Box sx={{ position: 'relative', 
                objectFit: 'cover',
                backgroundImage: `url(${BGI})`,                
                backgroundSize: 'cover',    
                backgroundPosition: 'center',
                width: '100%',
                height: (screenWidth * 226 / 375),
            }}>

                <Box sx={{ position: 'absolute', left: 0, top: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.25)', justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                    <Typography fontSize={32} fontWeight={700} color={'#FBBF23'} textAlign={'center'}>
                        {t('t96')}
                    </Typography>

                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignContent: 'center', alignItems: 'center', paddingTop: '8px'}}>
                        <Typography fontSize={14} fontWeight={400} color={'#FFFFFF'} textAlign={'center'}>
                            {t('t97')}
                        </Typography>
                        <Box sx={{ width: '1px', height: '20px', backgroundColor: '#FFFFFF', marginLeft: '20px', marginRight: '20px' }}></Box>
                        <Typography fontSize={14} fontWeight={400} color={'#FFFFFF'} textAlign={'center'}>
                            {t('t96')}
                        </Typography>
                    </Box>
                </Box>
            </Box>
            <SMAppAboutCredit />
            <SMAppVissionAndMission />
            <SMAppOurExtensive />
            <SMAppSalesStatistics />
            <SMAppMotorLoanIntroduction />
            <SMAppHomeContactUs />
        </>
    )
}

// ======================= EXPORT
export default AppAboutUsScreen
